import T from 'prop-types';
import React, { memo } from 'react';

import { be, bm } from '@skippay/core/utils/classUtils';

import Logo from 'components/Logo';

import './index.sass';

const MODULE_NAME = 'PageLoaderBackground';

const PageLoaderBackground = memo(function PageLoaderBackground(props) {
	const { animated, hideLogo } = props;

	return (
		<div className={bm(MODULE_NAME, { animated })}>
			{!hideLogo && (
				<div className={be(MODULE_NAME, 'logo')}>
					<Logo inverted wide />
				</div>
			)}
		</div>
	);
});

PageLoaderBackground.propTypes = {
	animated: T.bool,
	hideLogo: T.bool,
};

export default PageLoaderBackground;
